import { render } from "./ForgetPasswordLink.vue?vue&type=template&id=3e331824"
import script from "./ForgetPasswordLink.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordLink.vue?vue&type=script&lang=js"

import exportComponent from "/Users/denis/Documents/Работа/bitbucket/mifab/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__